var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[_c('div',{staticClass:"topContent"},[_c('ViewWrapper',{attrs:{"size":_vm.size}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.topData.title))])]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.topData.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }